import React, {useState, useEffect, useRef} from 'react';
import cx from 'classnames';
import cookie from 'js-cookie';
import {Modal, Slide} from '@mui/material';
import {Backdrop} from 'src/components/backdrop';
import {Signup} from 'src/components/signup';
import {StyledTitle} from 'src/components/styled-title';
import {useStoreContext, useToggleSignupDrawer} from 'src/context/storeContext';
import {useSignupPromoData} from 'src/hooks/useSignupPromoData';
import {ReactComponent as X} from 'src/images/svg/X.svg';
import {BlockContent} from 'src/components/block-content';

import * as styles from './signup-drawer.module.css';

export const SignupDrawer = ({location}) => {
	const {showTimeout, leftColumnCopy, centerColumnCopy, successCopy} =
		useSignupPromoData();

	const [locationPath, setLocationPath] = useState(location.pathname);
	const [active, setActive] = useState(false);
	const [visible, setVisible] = useState(false);
	const visibleTimeout = useRef(null);

	const promoCookie = 'erica-weiner_hide-signup-promo';

	// Set active if not seen
	useEffect(() => {
		const hasSeenPromo = cookie.get(promoCookie);
		if (!hasSeenPromo) {
			setActive(true);
		}
	}, []);

	// Dismiss and set hide promo cookie
	const onClose = () => {
		setActive(false);
		cookie.set(promoCookie, 'true', {expires: 7});
	};

	// Close promo when the route changes but don't save the cookie :)
	useEffect(() => {
		if (locationPath !== location.pathname) {
			setActive(false);
			setLocationPath(location.pathname);
		}
	}, [location]);

	// Reveal promo after timeout
	useEffect(() => {
		clearTimeout(visibleTimeout.current);

		if (active) {
			visibleTimeout.current = setTimeout(
				() => setVisible(true),
				showTimeout * 1000,
			);
		} else {
			setVisible(false);
		}
	}, [active]);

	return (
		<>
			<Modal
				open={visible}
				onClose={onClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					active: visible,
					toggle: onClose,
				}}
				aria-modal="true"
				aria-labelledby="menuTitle">
				<Slide
					direction="up"
					in={visible}
					timeout={{
						enter: 400,
						exit: 250,
					}}>
					<div
						className={cx(styles.signupDrawer)}
						role="presentation">
						<button
							className={cx('reset', styles.closeButton)}
							onClick={onClose}>
							<X />
						</button>
						<div className={styles.inner}>
							<div className={styles.leftColumn}>
								<StyledTitle
									className={styles.leftColumnCopy}
									styledTitle={leftColumnCopy}
								/>
							</div>
							<div className={styles.centerColumn}>
								<StyledTitle
									className={styles.centerColumnCopy}
									styledTitle={centerColumnCopy}
								/>
							</div>
							<div className={styles.rightColumn}>
								<Signup
									className={styles.signupForm}
									successComponent={
										<BlockContent
											className={styles.successMessage}
											copy={successCopy}
										/>
									}
								/>
							</div>
						</div>
					</div>
				</Slide>
			</Modal>
		</>
	);
};
